import React, { useEffect, useState } from 'react'
import "../../Css/Home/HomeTrending.css"
import { Link } from 'react-router-dom'
import image01 from "../../Images/product/image01.jpg"; // Not used directly in rendering, can be removed if not needed elsewhere
import image02 from "../../Images/product/image02.jpg"; // Not used directly in rendering, can be removed if not needed elsewhere
import axios from 'axios';

import product_image_not_found from "../../Images/product_image_not_found.jpg";
const HomeTrending = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleFetch = async () => {
        try {
            setLoading(true);
            const resp = await axios.get(
                `https://api.woodsy.co.in/api/wood-images-product`,);

            if (resp) {
                setData(resp?.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const dbounce = setTimeout(() => {
            handleFetch();
        }, 1000);
        return () => {
            clearTimeout(dbounce);
        };
    }, []);
    
    console.log("Trending products",data)

    return (
        <div>
            <section className='home-trending-section'>
                <div className='container'>
                    <div className='home-trending-section-head-con'>
                        <h3 className='ttcmsabout-title'>Trending products</h3>
                    </div>

                    <div className='home-trending-section-card-main-con'>
                        <div className='row'>
                            {data.map((item, index) => {
                                const { product, price, images } = item;

                                const productName = product?.name || "Product Name";
                                const productSlug = product?.slug || "#";
                                const firstImage = images && images.length > 0 ? images[0] : product_image_not_found;
                                const secondImage = images && images.length > 1 ? images[1] : firstImage;
                                const mainPrice = price && price.length > 0 ? price[0].price : null;
                                // const productdescription = product?.description || "description"; // Not used in render

                                return (
                                    <div className='col-lg-3 col-md-3 mb-4' key={index}>
                                        <div className='home-trending-section-card-body-con'>
                                            <Link to={`/product-details/${productSlug}`}>
                                                <div className='product-wrapper imgloaded'>
                                                    <div className='thumbs product-thumb'>
                                                        <div className='view-image fade_img'>
                                                            <div className='grid-view-item__link'>
                                                                <img
                                                                    className='image_thumb_swap'
                                                                    src={secondImage}
                                                                    alt={productName}
                                                                    onError={(e) => (e.target.src = product_image_not_found)}
                                                                />
                                                                <img
                                                                    className='grid-view-item__image featured-image image_thumb'
                                                                    src={firstImage}
                                                                    alt={productName}
                                                                    onError={(e) => (e.target.src = product_image_not_found)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='home-trending-section-car-details'>
                                                            <h3>{productName}</h3>
                                                            {/* <h4>{productdescription}</h4> */}
                                                            {mainPrice ? (
                                                                <p>
                                                                    ₹ {parseFloat(mainPrice).toFixed(2)} / unit
                                                                    <span className='discount-percentage'> -30%</span>
                                                                    <s className='product-price__price compare_price'>
                                                                        <span className='money'>₹ {(parseFloat(mainPrice) * 1.3).toFixed(2)}</span>
                                                                    </s>
                                                                </p>
                                                            ) : (
                                                                <p>Price Not Available</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default HomeTrending